import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { getPrivateRentMonthly } from "web_myplann/Goals/Helpers/getPrivateRentMonthly";
import { isRentBasedCategory } from "web_myplann/Goals/Helpers/goalCategory";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import {
	GoalCategoryTypeEnum,
	type GoalDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const mapGoalDtoToForm = (
	dto: GoalDetailResponseDTO,
): Partial<GoalFormModel> => {
	const isPension =
		dto.investmentPlanCategoryType === GoalCategoryTypeEnum.Pension;
	const isRentBased = isRentBasedCategory(dto.investmentPlanCategoryType);
	const hasRentYears = (dto.rentYears ?? 0) > 0;
	const drawdownMode = isRentBased
		? hasRentYears
			? RentDrawdownMode.ToZero
			: RentDrawdownMode.Perpetual
		: undefined;

	const totalValue = dto.oneTimePayment ?? dto.targetAmount ?? undefined;

	const storedMonthlyRent = dto.monthlyRent ?? 0;
	const privateMonthly = drawdownMode
		? getPrivateRentMonthly({
				price: totalValue,
				monthlyRent: storedMonthlyRent,
				drawdownMode,
				rentYears: dto.rentYears ?? 0,
			})
		: 0;

	const monthlyRent = isRentBased
		? storedMonthlyRent || privateMonthly || undefined
		: undefined;
	const derivedStatePension = Math.max(0, storedMonthlyRent - privateMonthly);
	const statePension = isPension
		? (dto.statePension ?? derivedStatePension) || undefined
		: undefined;

	return {
		category: dto.investmentPlanCategoryType,
		name: dto.name ?? "",
		dueDate: dto.targetDate ? new Date(dto.targetDate) : undefined,
		totalValue,
		ownFunds: dto.ownFunds ?? 0,
		loanAmount: dto.loanAmount ?? 0,
		monthlyRent,
		statePension,
		rentYears: dto.rentYears ?? undefined,
		drawdownMode,
	};
};
